import { render, staticRenderFns } from "./history.vue?vue&type=template&id=329c1e23&scoped=true"
import script from "./history.vue?vue&type=script&lang=js"
export * from "./history.vue?vue&type=script&lang=js"
import style0 from "./history.vue?vue&type=style&index=0&id=329c1e23&prod&lang=css"
import style1 from "./history.vue?vue&type=style&index=1&id=329c1e23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329c1e23",
  null
  
)

export default component.exports